export default __webpack_public_path__ + "a685b6ee6450ed1f799543ca1d5f8b33.png";